import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {SERVICE_CONFIG, TaskService} from '../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {UtilsModule} from '../../utils/utils.module';

@Component({
  selector: 'nf-task-abnormal-statistics',
  templateUrl: './task-abnormal-statistics.component.html',
  styleUrls: ['./task-abnormal-statistics.component.css']
})
export class TaskAbnormalStatisticsComponent implements OnInit {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  indicatorExceptionCount = 0;
  auditExceptionCount = 0;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = data;
    }
  }
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private util: UtilsModule,
  ) { }

  ngOnInit(): void {
    this.handleExceptionCount(this.pulse.columnValues[this.column.id]);
  }
  handleExceptionCount(content) {
    this.indicatorExceptionCount = 0;
    this.auditExceptionCount = 0;
    if (content && content.indicatorItemStatistic) {
      for (const m in content.indicatorItemStatistic) {
        if (content.indicatorItemStatistic.hasOwnProperty(m)) {
          this.indicatorExceptionCount += content.indicatorItemStatistic[m].exceptionCount ? content.indicatorItemStatistic[m].exceptionCount : 0;
        }
      }
    }
    if (content && content.auditItemStatistic) {
      for (const n in content.auditItemStatistic) {
        if (content.auditItemStatistic.hasOwnProperty(n)) {
          this.auditExceptionCount += content.auditItemStatistic[n].exceptionCount ? content.auditItemStatistic[n].exceptionCount : 0;
        }
      }
    }
  }
}
